import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Header />
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Terms and Conditions
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            Last updated: February 18, 2026
          </p>

          <Card className="p-8">
            <div className="prose prose-lg dark:prose-invert max-w-none">
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Welcome to <strong>allseoconferences.com</strong> (the "Site"). These Terms and Conditions ("Terms", "Agreement") govern your access to and use of the Site and the services provided through it. By accessing or using this Site, you agree to be bound by these Terms. If you do not agree, please do not use the Site.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                1. Acceptance of Terms
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                By using this Site, you confirm that you are at least 18 years old (or of legal age in your jurisdiction) and that you agree to comply with all terms, conditions, and notices contained or referenced herein.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                2. Changes to Terms
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                We may update these Terms at any time. Updated terms take effect immediately upon posting. Your continued use of the Site after changes means you accept the updated Terms.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                3. Use of the Site
              </h2>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 mt-6">
                Permitted Use
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                You may use the Site for lawful purposes and in accordance with these Terms. You agree not to use the Site:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-600 dark:text-gray-400 space-y-2">
                <li>In any way that violates applicable laws or regulations.</li>
                <li>To attempt to interfere with the Site's operation or security.</li>
                <li>To upload, post, transmit, or otherwise make available content that is unlawful, harmful or violates third-party rights.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 mt-6">
                Account and Submissions
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                If you submit any content (e.g., conference details), you represent that you own the rights to that content and grant us a non-exclusive license to use, reproduce, modify, and display it. You agree not to submit content that is illegal, infringing, or offensive.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                4. Intellectual Property
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                All content on this Site — including text, graphics, logos, and software — is protected by copyright, trademark, and other laws. Except as expressly permitted, you may not copy, reproduce, republish, or distribute Site content without our written consent.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                5. Fees and Payments
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Certain services (such as event submissions) may involve fees. By submitting payment, you agree to the pricing and payment terms communicated at checkout. All fees are non-refundable unless otherwise specified.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                6. Third-Party Links
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                The Site may contain links to third-party websites. We are not responsible for the content or practices of those sites and make no warranties regarding them.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                7. Disclaimers
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                The Site and its content are provided <strong>"as is"</strong> and <strong>"as available"</strong> without warranties of any kind, either express or implied. We do not guarantee that the Site will be uninterrupted, secure, or error-free.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                8. Limitation of Liability
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                To the fullest extent permitted by law, <strong>allseoconferences.com</strong> and its affiliates will not be liable for any indirect, incidental, special, consequential or punitive damages arising from your use of the Site.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                9. Governing Law
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                These Terms are governed by the laws of the jurisdiction where the Site owner is based. Disputes arising out of these Terms will be resolved in the appropriate courts of that jurisdiction.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                10. Termination
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                We may suspend or terminate access to the Site at any time for any reason, including if you violate these Terms.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">
                11. Contact Information
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                If you have questions about these Terms, contact us at: <a href="mailto:hello@allseoconferences.com" className="text-purple-600 dark:text-purple-400 hover:underline">hello@allseoconferences.com</a>
              </p>

              <div className="border-t border-gray-200 dark:border-gray-700 pt-6 mt-8">
                <p className="text-gray-600 dark:text-gray-400 font-semibold text-center">
                  By using allseoconferences.com, you agree to these Terms and Conditions.
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;